// extracted by mini-css-extract-plugin
export default {"root":"_1XcT-","fade-in":"_2oIvx","hide":"_2SrGk","fade-out":"_1Wa_S","closeBtn":"kAFOx"};